import {Breadcrumbs} from '@management-ui/core';
import {Paper} from '@mui/material';
import * as React from 'react';
import Table from './Table';

const OutboundMessages = () => (
  <div>
    <Breadcrumbs crumbs={[{title: 'Emails'}]}/>
    <Paper>
      <Table/>
    </Paper>
  </div>
);

export default OutboundMessages;
